module.exports = __webpack_public_path__ + "static/media/notice.952d18a5.svg";